<template>
  <v-text-field
    v-model="model"
    v-debounce="onDebounce"
    variant="underlined"
    v-bind="$attrs"
    color="primary"
  />
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

defineOptions({
  name: 'SfDebouncedTextField',
  inheritAttrs: false
})

const emit = defineEmits<{ debounce: [string] }>()

const [model, modifiers] = defineModel<string | number | null>({
  set(value): string | number | null {
    return value
  }
})

const attrs = useAttrs()

const normalize = (value: string) => {
  return modifiers.noFixSpaces ? value : value.trim().replace(/\s{2,}/g, ' ')
}

const onDebounce = (value: string) => {
  if (!attrs.readonly) {
    const normalized = normalize(value)
    if (model.value !== normalized) {
      model.value = normalized
    }
    emit('debounce', normalized)
  }
}
</script>
